import { module } from "angular";
import { IrisityBackgroundWrapperDirective } from "./IrisityBackgroundWrapperDirective";

module("mmAuth").directive("irIrisityBackgroundWrapper", () => new IrisityBackgroundWrapperDirective());
